import React, { Component } from 'react';
import AuthNavbar from '../navigation/authnavigation.jsx'
import GuestNavbar from '../navigation/guestnavbar.jsx'
import PDSComp from '../PDS/pds.jsx'
import LeftLink from '../leftlink/leftlink.jsx'

class PDS extends Component {
    render() {
        return (
            <div>
                {localStorage.getItem("loginState") === "true" ?
                    <div className="row" >
                        <div className="col-sm-12">
                            <AuthNavbar />
                        </div>
                        <div className="container" style={{ marginTop: "80px" }}>
                            <div className="row">
                                <div className="col-sm-3 box-shadow-style nopadding" style={{ minHeight: "470px" }}>
                                    <LeftLink />
                                </div>
                                <div className="col-sm-9" style={{ padding: "0px 30px" }}>

                                    <div className="row box-shadow-style" style={{ padding: "12px 0px", minHeight: "476px" }}>
                                        <PDSComp />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div>
                        <div className="col-sm-12">
                            <GuestNavbar />
                        </div>
                        <div className="container" style={{ marginTop: "80px" }}>
                            <div className="row">
                                <PDSComp />
                            </div>
                        </div>
                    </div>}
            </div>
        );
    }
}

export default PDS;


// WEBPACK FOOTER //
// ./src/components/authpages/pds.jsx